import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  CreateCustomerAndShareMenuShareBody,
  DigitalMenuShareCustomerApi,
  EntityApi,
  FindDigitalMenuShareCustomerOptions,
  ShareMenuShareWithCustomerBody,
  UpdateMenuShareForCustomerBody,
} from 'api';

export const findEntityToShareDigitalMenuShareFromMenu = createAsyncThunk<
  any,
  { menuID: string; options: { name: string } },
  { rejectValue: { message: string } }
>(
  'entity/findEntityToShareDigitalMenuShareFromMenu',
  async ({ menuID, options }, { rejectWithValue }) => {
    try {
      const response = await EntityApi.findToShareDigitalMenuShareFromMenu(
        menuID,
        options
      );
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findDigitalMenuShareCustomersByMenuID = createAsyncThunk<
  any,
  { menuID: string; options: FindDigitalMenuShareCustomerOptions },
  { rejectValue: { message: string } }
>(
  'digitalMenuShareCustomer/findDigitalMenuShareCustomersByMenuID',
  async ({ menuID, options }, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuShareCustomerApi.findByMenuID(
        menuID,
        options
      );
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const shareDigitalMenuShareWithCustomerFromMenu = createAsyncThunk<
  any,
  { menuID: string; body: ShareMenuShareWithCustomerBody },
  { rejectValue: { message: string } }
>(
  'digitalMenuShareCustomer/shareDigitalMenuShareWithCustomerFromMenu',
  async ({ menuID, body }, { rejectWithValue }) => {
    try {
      const response =
        await DigitalMenuShareCustomerApi.shareWithCustomerFromMenu(
          menuID,
          body
        );
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createCustomerAndShareDigitalMenuShareFromMenu = createAsyncThunk<
  any,
  { menuID: string; body: CreateCustomerAndShareMenuShareBody },
  { rejectValue: { message: string } }
>(
  'digitalMenuShareCustomer/createCustomerAndShareDigitalMenuShareFromMenu',
  async ({ menuID, body }, { rejectWithValue }) => {
    try {
      const response =
        await DigitalMenuShareCustomerApi.createCustomerAndShareFromMenu(
          menuID,
          body
        );
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removePricePolicyMenuShareCustomer = createAsyncThunk<
  any,
  { menuShareCustomerID: string },
  { rejectValue: { message: string } }
>(
  'digitalMenuShareCustomer/removePricePolicyMenuShareCustomer',
  async ({ menuShareCustomerID }, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuShareCustomerApi.removePricePolicy(
        menuShareCustomerID
      );
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateDigitalMenuShareForCustomer = createAsyncThunk<
  any,
  { menuShareCustomerID: string; body: UpdateMenuShareForCustomerBody },
  { rejectValue: { message: string } }
>(
  'digitalMenuShareCustomer/updateDigitalMenuShareForCustomer',
  async ({ menuShareCustomerID, body }, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuShareCustomerApi.updateDigitalMenuShare(
        menuShareCustomerID,
        body
      );
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteDigitalMenuShareCustomer = createAsyncThunk<
  any,
  { menuShareCustomerID: string },
  { rejectValue: { message: string } }
>(
  'digitalMenuShareCustomer/deleteDigitalMenuShareCustomer',
  async ({ menuShareCustomerID }, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuShareCustomerApi.delete(
        menuShareCustomerID
      );
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface DigitalMenuShareCustomerState {
  data: any[];
}

const initialState: DigitalMenuShareCustomerState = {
  data: [],
};

const digitalMenuShareCustomerSlice = createSlice({
  name: 'digitalMenuShareCustomer',
  initialState,
  reducers: {},
  //   extraReducers: builder => {},
});

const { reducer: digitalMenuShareCustomerReducer } =
  digitalMenuShareCustomerSlice;

export default digitalMenuShareCustomerReducer;
